module.exports = {
  GROUP_HOME_APP_DEFINITION_ID: "15267a74-e34b-25c8-3746-0332c3ea4122",
  GROUP_HEADER_APP_DEFINITION_ID: "15267af9-cd58-df1e-06a5-0676b7df5b5c",
  GROUP_ML_APP_DEFINITION_ID: "152f10b2-3752-c46e-3218-2c70c6fed57d",
  GROUPS_APP_DEFINITION_ID: "148c2287-c669-d849-d153-463c7486a694",
  GROUPS_ROOT_MODAL_LOADER_ID: "152f66a4-6ee6-0245-3218-2c70c6fed57d",
  GROUPS_HORIZONTAL_MENU_ID: "1531e3d2-e77a-c2fe-e520-5a250a71a733",
  FORUM_APP_DEFINITION_ID: "14724f35-6794-cd1a-0244-25fd138f9242",
  MEMBERS_AREA_APP_DEFINITION_ID: "14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9"
}
